<template>
    <div class="flex h-full w-full p-3"
         :class="{ 'bg-grey-10': solutionTotalCounts, 'items-center justify-center': !solutionTotalCounts }">
        <CatLoading v-if="solutionListLoading" />
        <ResultTutorial v-else-if="!haveSearched" />
        <ResultEmpty v-else-if="haveSearched && solutionListEmpty" />
        <div class="h-full w-full" v-else>
            <section class="idea-result-header mb-3 flex h-8 items-center justify-between gap-2 text-grey-90">
                <span></span>

                <div class="flex shrink-0 items-center gap-2">
                    <span class="th-tooltip th-tooltip-bottom-start cursor-pointer" :data-tip="$t('resultTitle')">
                        <PtIcon icon="SolidInfo" class="fill-grey-90 text-2xl hover:fill-grey-450" />
                    </span>
                    <SuggestPatentNumber @update:handleChosen="liftByPatentNumber" />
                    <BatchSave :result="{ solutionIds }" :withTooltip="false"
                               :outline="true"
                    />

                    <GenerateReport :userCheckedReportTotal="userCheckedReportTotal"
                                    :userConfirmReportList="userConfirmReportList"
                                    @update:handle-remove="handleRemove"
                                    @update:handleSubmit="handleGoReport" />
                </div>
            </section>

            <SolutionCard class="mb-4" v-for="(item, index) in solutions" :key="item.patent_id"
                          :solutionBasic="item" :solutionOrder="index + 1" @toggle:intoReportList="toggleIntoReportList">
                <template v-slot:image-row v-if="item.pdf_image_count">
                    <ImageRow class="mt-4 gap-2" :solution-profile="item" @openImagePanel="openCardImagePanel"></ImageRow>
                </template>
            </SolutionCard>
        </div>

        <ImagePanel v-show="imagePanelService.isShow" :service="imagePanelService" />
    </div>
</template>

<script setup lang="ts">
import ResultTutorial from '@/components/result/ResultTutorial.vue'
import SolutionCard from '@/components/result/SolutionCard.vue'
import GenerateReport from '@/components/result/GenerateReport.vue'
import SuggestPatentNumber from '@/components/result/SuggestPatentNumber.vue'
import ImageRow from '@/components/result/ImageRows.vue'
import { ImagePanel } from '@eureka/shared/solution-card';
import ResultEmpty from '@/components/result/ResultEmpty.vue'
import { BatchSave } from '@eureka/shared/eureka-save';
import { CatLoading } from '@eureka/cat'
import { useResultReport } from './use-result-report';
import { useIdeaResult } from './use-idea-result';
import { PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/info.svg';

const {
    solutions,
    solutionIds,
    solutionTotalCounts,
    haveSearched,
    imagePanelService,
    solutionListLoading,
    solutionListEmpty,
    liftByPatentNumber,
    openCardImagePanel,
} = useIdeaResult()

const { userCheckedReportTotal, userConfirmReportList, toggleIntoReportList, handleGoReport, handleRemove } = useResultReport()

</script>
